import { render, staticRenderFns } from "./addScheme.vue?vue&type=template&id=ee1f299c&scoped=true&"
import script from "./addScheme.vue?vue&type=script&lang=js&"
export * from "./addScheme.vue?vue&type=script&lang=js&"
import style0 from "./addScheme.vue?vue&type=style&index=0&id=ee1f299c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1f299c",
  null
  
)

export default component.exports